<div class="hr-modal-header">
  <div class="hr-close-tooltip">
    <button
      class="hr-btn-round hr-modal-close"
      id="hrClosePreviewModal"
      (click)="closeModal()"
    >
      <svg-icon src="/assets/icons/close.svg"></svg-icon>
    </button>
    <span>Fechar</span>
  </div>
  <h1>Prévia da proposta</h1>
</div>

<div class="hr-modal-body offer-pdf-preview-body">
  <div *ngIf="isLoading" class="dq-loader-overlay">
    <div class="hr-loader-area">
      <div class="loader">Loading...</div>
      <label>Aguarde enquanto processamos sua ação...</label>
    </div>
  </div>

  <ng-container *ngIf="!isLoading">
    <iframe class="offer-pdf-preview-frame" [src]="pdfUrl"></iframe>

    <div class="offer-pdf-preview-actions">
      <button
        class="offer-button-area primary"
        [disabled]="disabledBttns"
        (click)="onAcceptOffer()"
      >
        <span>Aceitar proposta</span>
      </button>
      <button
        *ngIf="propostaService.getView().status !== aceito"
        class="offer-button-area secondary"
        [disabled]="disabledBttns"
        (click)="openModalRejectOffer()"
      >
        <span>Recusar proposta</span>
      </button>
    </div>
  </ng-container>
</div>

<hr-ol-pdf-acceptance
  style="display: none"
  #olPdfAcceptance
></hr-ol-pdf-acceptance>
